import Radio from 'components/Radio';
import { companyStatus } from 'utils/constants';

interface CompanyStatusProps {
  currentCompanyStatus: companyStatus | null;
  onCompanyStatusChange: (value: companyStatus) => void;
}

const CompanyStatus = ({
  currentCompanyStatus,
  onCompanyStatusChange
}: CompanyStatusProps) => {
  return (
    <div className='flex flex-col items-start gap-2 pb-3'>
      <p className='text-base font-light'>Company Status*</p>
      <div className='flex flex-row justify-start items-center gap-6 pt-3'>
        <Radio
          name='public'
          value={companyStatus.PUBLIC}
          selected={currentCompanyStatus}
          label='Public'
          onChange={onCompanyStatusChange}
        />
        <Radio
          name='private'
          value={companyStatus.PRIVATE}
          selected={currentCompanyStatus}
          label='Private'
          onChange={onCompanyStatusChange}
        />
      </div>
      {currentCompanyStatus === companyStatus.PUBLIC && (
        <p className='text-sm font-light mt-1'>
          Please do not provide any material non-public information
        </p>
      )}
    </div>
  );
};

export default CompanyStatus;
